import { useAuth } from "../lib/auth";

const colors = {
  cream: "#fdf6ec",
  parchment: "#fce8d5",
  terra: "#6b3fa0",
  ink: "#3d1e5c",
  inkLight: "#b07a80",
  white: "#ffffff",
  errorBg: "#fff0f0",
  errorText: "#a02020",
};

const fontStack = "'Georgia', 'Times New Roman', serif";

export default function LoginGate() {
  const { signInWithGoogle, state, error } = useAuth();
  const isBusy = state.status === "loading";

  return (
    <div
      style={{
        minHeight: "100vh",
        background: colors.cream,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: "24px",
        fontFamily: fontStack,
      }}
    >
      <div
        style={{
          background: colors.white,
          border: `1px solid ${colors.parchment}`,
          borderRadius: 20,
          boxShadow: "0 4px 28px rgba(45,32,22,0.08)",
          padding: "40px 32px",
          maxWidth: 420,
          width: "100%",
          textAlign: "center",
        }}
      >
        <div style={{ fontSize: 44, marginBottom: 8 }}>🌅</div>
        <h1
          style={{
            margin: "0 0 8px",
            fontSize: 28,
            color: colors.ink,
            letterSpacing: -0.5,
          }}
        >
          Life Command Center
        </h1>
        <p
          style={{
            margin: "0 0 28px",
            color: colors.inkLight,
            fontSize: 14,
            lineHeight: 1.5,
          }}
        >
          Sign in to sync your daily checklist across devices.
        </p>

        <button
          type="button"
          onClick={signInWithGoogle}
          disabled={isBusy}
          style={{
            width: "100%",
            padding: "12px 16px",
            background: colors.terra,
            color: colors.white,
            border: "none",
            borderRadius: 14,
            fontFamily: fontStack,
            fontSize: 15,
            fontWeight: 600,
            cursor: isBusy ? "wait" : "pointer",
            opacity: isBusy ? 0.7 : 1,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            gap: 10,
          }}
        >
          <GoogleIcon />
          {isBusy ? "Signing in…" : "Continue with Google"}
        </button>

        {error && (
          <div
            role="alert"
            style={{
              marginTop: 16,
              padding: "10px 14px",
              background: colors.errorBg,
              color: colors.errorText,
              borderRadius: 10,
              fontSize: 13,
              textAlign: "left",
            }}
          >
            {error}
          </div>
        )}

        <p
          style={{
            marginTop: 24,
            color: colors.inkLight,
            fontSize: 11,
            lineHeight: 1.4,
          }}
        >
          Your checklist data is private and only visible to you.
        </p>
      </div>
    </div>
  );
}

function GoogleIcon() {
  return (
    <svg width="18" height="18" viewBox="0 0 18 18" aria-hidden="true">
      <path
        fill="#fff"
        d="M17.64 9.2c0-.64-.06-1.25-.16-1.84H9v3.48h4.84a4.14 4.14 0 0 1-1.8 2.72v2.26h2.92c1.7-1.56 2.68-3.88 2.68-6.62z"
      />
      <path
        fill="#fff"
        opacity="0.85"
        d="M9 18c2.43 0 4.47-.8 5.96-2.18l-2.92-2.26c-.8.54-1.84.86-3.04.86-2.34 0-4.32-1.58-5.03-3.7H.92v2.32A9 9 0 0 0 9 18z"
      />
      <path
        fill="#fff"
        opacity="0.75"
        d="M3.97 10.72A5.4 5.4 0 0 1 3.68 9c0-.6.1-1.18.29-1.72V4.96H.92A9 9 0 0 0 0 9c0 1.45.35 2.82.92 4.04l3.05-2.32z"
      />
      <path
        fill="#fff"
        opacity="0.95"
        d="M9 3.58c1.32 0 2.5.46 3.44 1.35l2.58-2.58C13.46.89 11.42 0 9 0A9 9 0 0 0 .92 4.96l3.05 2.32C4.68 5.16 6.66 3.58 9 3.58z"
      />
    </svg>
  );
}
